let settings = {
  OpenIdProvider: {
    login: 'https://authentication.atlantico.fr/sign-in',
    refresh: 'https://authentication.atlantico.fr/refresh-token',
    users: 'https://authentication.atlantico.fr/users'
  },
  bestOfApi: 'https://best-of.atlantico.fr/best-of',
  servingApi: 'https://serving.atlantico.fr',
  bestOfArticlePath: "https://atlantico.fr/article/decryptage",
  PaymentProvider: {
    paymentApi: 'https://payments.atlantico.fr',
    stripeDashboardUrl: 'https://dashboard.stripe.com/',
    profitwellUrl: ''
  },
  strapiAdminApi: 'https://admin-back.atlantico.fr/',
  strapiUrl: 'https://strapi.atlantico.fr/',
  baseUrl: "/",
  frontUrl: "https://atlantico.fr/",
  analyticsApi: "https://analytics.atlantico.fr/",
  newsletterApi: "https://newsletter.atlantico.fr/",
  sharingApi: "https://sharing.atlantico.fr/",
  notifApi: "https://notifications-mobile.atlantico.fr/",
}

// if preprod
if (false) {
  settings = {
    OpenIdProvider: {
      login: 'https://authentication-atlantico-preprod.rubrash.network/sign-in',
      refresh: 'https://authentication-atlantico-preprod.rubrash.network/refresh-token',
      users: 'https://authentication-atlantico-preprod.rubrash.network/users'
    },
    bestOfApi: 'https://best-of-atlantico-preprod.rubrash.network/best-of',
    servingApi: 'https://serving-atlantico-preprod.rubrash.network',
    bestOfArticlePath: "https://atlantico-preprod.rubrash.network/article/decryptage",
    PaymentProvider: {
      paymentApi: 'https://payment-atlantico-preprod.rubrash.network',
      stripeDashboardUrl: 'https://dashboard.stripe.com/test/',
      profitwellUrl: 'https://www2.profitwell.com/app/'
    },
    strapiAdminApi: 'https://admin-atlantico-preprod.rubrash.network/',
    strapiUrl: 'https://strapi-atlantico-preprod.rubrash.network/',
    baseUrl: "/",
    frontUrl: "https://atlantico-preprod.rubrash.network/",
    analyticsApi: "https://analytics-atlantico-preprod.rubrash.network/",
    newsletterApi: "https://tjutfsqadi.execute-api.eu-west-3.amazonaws.com/",
    sharingApi: "https://sharing-preprod.atlantico.fr/",
    notifApi: "https://notifications-mobile-preprod.atlantico.fr/",
  }
}

export default settings;
